/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
// noinspection ES6CheckImport
import {Pagination, Table} from 'antd';
import CurrencyFormat from 'react-currency-format';
import Button from '@material-ui/core/Button';
import {formatDate} from '../../modules/utils';
import {useDispatch, useSelector} from 'react-redux';
import {
  SELECTOR_OTHERS_ORDERS,
  SELECTOR_OTHERS_ORDERS_TOTALS,
} from '../../redux/selectors/orders';
import {getOthersOrders} from '../../redux/actions/orders';

import 'antd/dist/antd.css';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import api from '../../services/api';
import AppDialog from '../../components/AppDialog';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableMui from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
  contentPagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 15,
  },
  table: {
    minWidth: 700,
  },
  title: {
    fontWeight: 700,
  },
});

function OthersOrdersTable() {
  const orders = useSelector(SELECTOR_OTHERS_ORDERS);
  const pagination = useSelector(SELECTOR_OTHERS_ORDERS_TOTALS);

  const [openOther, setOpenOther] = useState(false);
  const [currentOther, setOther] = useState(false);

  const isMobil = useMediaQuery('(max-width:510px)');
  const dispatch = useDispatch();
  const classes = useStyles();

  const columns = isMobil
    ? [
        {
          render: ({numero, fecha: date, valor_total: price}) => {
            return (
              <div>
                <div>
                  Pedido Nro: <span>{numero}</span>
                </div>
                <div>
                  Fecha: <span>{formatDate(date)}</span>
                </div>
                <div>
                  Valor total:
                  <CurrencyFormat
                    value={price}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                    renderText={(value) => <span>{value}</span>}
                  />
                </div>
                <div>
                  <Button
                    variant="outlined"
                    size="small"
                    color="primary"
                    onClick={() => handleOpenOther(numero)}
                  >
                    Ver detalle del pedido
                  </Button>
                </div>
              </div>
            );
          },
        },
      ]
    : [
        {
          title: 'Pedido Nro.',
          dataIndex: 'numero',
          sorter: false,
          width: '20%',
        },
        {
          title: 'Notas',
          dataIndex: 'notas',
        },
        {
          title: 'Fecha',
          dataIndex: 'fecha',
          sorter: false,
          render: (date) => <span>{formatDate(date)}</span>,
        },
        {
          title: 'Valor total',
          dataIndex: 'valor_total',
          render: (price) => (
            <CurrencyFormat
              value={price}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              renderText={(value) => <span>{value}</span>}
            />
          ),
        },
        {
          title: '',
          dataIndex: 'numero',
          render: (id) => (
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={() => handleOpenOther(id)}
            >
              Ver detalle del pedido
            </Button>
          ),
        },
      ];

  useEffect(() => {
    getOrderData(0);
  }, []);

  function getOrderData(skip) {
    dispatch(getOthersOrders({query: {$skip: skip}}));
  }

  const handleOpenOther = async (id) => {
    try {
      const data = await api.documentosPed
        .find({
          query: {
            numero: id,
          },
        })
        .then(async ({data}) =>
          data[0]
            ? {
                ...data[0],
                documentos_lin_ped: await api.documentosPedHistoria
                  .find({
                    query: {
                      numero: data[0].numero,
                    },
                  })
                  .then((it) => it.data),
              }
            : data[0],
        );
      setOpenOther(true);
      setOther(data);
    } catch (e) {}
  };

  return (
    <>
      <Table
        columns={columns}
        rowKey={(item) => item.id}
        dataSource={orders.reverse()}
        pagination={false}
      />
      <div className={classes.contentPagination}>
        <Pagination
          total={pagination.total}
          showSizeChanger={false}
          defaultPageSize={10}
          defaultCurrent={1}
          onChange={(current, pageSize) => {
            getOrderData((current - 1) * pageSize);
          }}
        />
      </div>
      <AppDialog handleClose={() => setOpenOther(false)} open={openOther}>
        <Box mt={8} mb={4} mx={4}>
          <TableContainer>
            <TableMui className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Producto</TableCell>
                  <TableCell align="right">Cantidad</TableCell>
                  <TableCell align="right">Valor unitario</TableCell>
                  <TableCell align="right">Valor total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentOther.documentos_lin_ped &&
                  currentOther.documentos_lin_ped[0]?.documentos_lin_ped_historia.map(
                    (it) => (
                      <TableRow>
                        <TableCell component="th" scope="row">
                          {it.referencia.descripcion}
                        </TableCell>
                        <TableCell align="right">{it.cantidad}</TableCell>
                        <TableCell align="right">
                          <CurrencyFormat
                            value={it.valor_unitario}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            renderText={(value) => <span>{value}</span>}
                          />
                        </TableCell>
                        <TableCell align="right">
                          <CurrencyFormat
                            value={
                              it.cantidad * it.cantidad_und * it.valor_unitario
                            }
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            renderText={(value) => <span>{value}</span>}
                          />
                        </TableCell>
                      </TableRow>
                    ),
                  )}
              </TableBody>
            </TableMui>
          </TableContainer>
        </Box>
      </AppDialog>
    </>
  );
}

export default OthersOrdersTable;
